export class TineDiagram {
  constructor(item) {
    if (item) {
      this.thumbTipRadius = item.thumbTipRadius;
      this.tipRadiusSideViewBase64Image = item.tipRadiusSideViewBase64Image;
      this.thumbBodyBase64Image = item.thumbBodyBase64Image;
      this.tineDiagram = item.tineDiagram;
      this.tipRadiusDiagram = item.tipRadiusDiagram;
      this.thumbTipRadius = item.thumbTipRadius;
      return;
    }
    this.thumbTipRadius = null;
    this.tipRadiusSideViewBase64Image = null;
    this.thumbBodyBase64Image = null;
    this.tineDiagram = null;
    this.tipRadiusDiagram = null;
    this.thumbTipRadius = 0;
  }
}
